import InputField from "components/form/InputField";
import { valuesProps } from "types/paymentMethods";
import LoaderRing from "components/ui-component/LoaderRing";
import React, { useEffect, useState } from "react";
import { getBankLogo } from "utils/HelperFunctions";
import { useTid } from "utils/testid";
interface BankFormProps {
  handleChange: (e: any, value: string) => void;
  values: valuesProps;
  numberNotmatchedError: boolean;
  bankName: string;
  errMsg: string | undefined;
  isRingLoading: boolean;
  disableInputFields?: boolean;
  error?: string | undefined;
  setnumberNotmatchedError: (val: boolean) => void;
}
const BankForm = ({
  handleChange,
  values,
  numberNotmatchedError,
  bankName,
  errMsg,
  isRingLoading,
  disableInputFields = false,
  error = undefined,
  setnumberNotmatchedError,
}: BankFormProps) => {
  const tid = useTid();
  const [logo, setLogo] = useState<any>(null);
  const [isErr, setIsErr] = useState<boolean>(false);
  useEffect(() => {
    if (bankName) {
      let logo = getBankLogo({ bankName, type: "small" });
      setLogo(logo || null);
    }
  }, [bankName]);

  return (
    <div
      className="flex flex-col w-full lg:gap-[30px] gap-5"
      data-testid={tid("bank-fields")}
    >
      <div className="w-full">
        <InputField
          name="choldername"
          data-testid={tid("bank-account-holder-input")}
          aria-label="Bank account holder name"
          label="Account holder name"
          className="!py-[10px] !rounded-[7px]"
          _className="!text-xs !font-bold !leading-normal"
          placeholder="Full name of account holder"
          value={values?.choldername}
          onChange={(e) => handleChange(e, "choldername")}
          disabled={disableInputFields}
        />
      </div>
      <div className="w-full">
        <InputField
          type="number"
          name="account_number"
          data-testid={tid("bank-account-number-input")}
          aria-label="Bank account number"
          label="Account Number"
          className={`!py-[10px] !rounded-[7px] ${
            isErr || numberNotmatchedError || error ? "!border-red" : ""
          }`}
          _className="!text-xs !font-bold !leading-normal"
          placeholder="Enter Account Number"
          value={values?.account_number}
          onChange={(e) => {
            handleChange(e, "account_number");
            setnumberNotmatchedError(false);
          }}
          disabled={disableInputFields}
        />
      </div>
      <div className="w-full">
        <InputField
          type="number"
          name="r_account_number"
          data-testid={tid("bank-confirm-account-number-input")}
          aria-label="Confirm bank account number"
          label="Re-enter Account Number"
          className={`!py-[10px] !rounded-[7px] ${
            isErr || numberNotmatchedError || error ? "!border-red" : ""
          }`}
          _className="!text-xs !font-bold !leading-normal"
          placeholder="Re-enter Account Number"
          value={values?.r_account_number}
          onChange={(e) => {
            handleChange(e, "r_account_number");
            setnumberNotmatchedError(false);
          }}
          error={
            numberNotmatchedError || isErr
              ? "Account number are not matched"
              : undefined
          }
          onBlur={() => {
            if (values?.r_account_number !== values?.account_number) {
              setnumberNotmatchedError(true);
            }
          }}
          disabled={disableInputFields}
        />
      </div>
      <div className="w-full relative">
        <InputField
          type="number"
          name="routing_number"
          data-testid={tid("bank-routing-number-input")}
          aria-label="Bank routing number"
          label="Routing Number"
          className={`!py-[10px] !rounded-[7px] ${error ? "!border-red" : ""}`}
          _className="!text-xs !font-bold !leading-normal"
          placeholder="Enter Routing Number"
          value={values?.routing_number}
          onChange={(e) => handleChange(e, "routing_number")}
          error={errMsg}
          disabled={disableInputFields}
        />
        {bankName && logo && !isRingLoading && (
          <div className="absolute right-[15px] top-[50%]" aria-hidden="true">
            {logo}
          </div>
        )}
        {!errMsg && bankName && (
          <div className="absolute top-[100%] left-0">
            <div
              className={`mt-[3px] text-xs leading-normal text-txtSecondary capitalize`}
            >
              {bankName?.toLowerCase()}
            </div>
          </div>
        )}
        {isRingLoading && (
          <div className="absolute right-[24px] top-[50%]">
            <div className="text-xs leading-[16px] text-gray1 ">
              <LoaderRing exsm />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BankForm;
